import { isEmpty } from 'lodash'
import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {}

const getActions = generateActions('static/GET_DOC')

export const get = createAction(
  API_CONST,
  (alias = null) => ({
    actions: getActions,
    url: `docs/${alias}`
  }),
  alias => ({ alias })
)

export default handleActions({
  [getActions[1]]: (state, { payload, meta }) => ({
    ...state,
    [meta.alias]: (!payload || isEmpty(payload)) ? null : payload
  }),
  [getActions[2]]: (state, { meta, payload }) => ({
    ...state,
    [meta.alias]: payload.status === 301 ? undefined : null
  })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/static/index.js